import React, { useState, useEffect } from 'react';
import { numberRegex, programDescriptionRegex, programNameRegex } from '../regex/regex';
import SwitchButton from '../component/SwitchButton';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { StyledButton, StyledCancelButton } from '../component/StyledComponent';
import StatusDialog from './StatusDialog';
import { baseUrl } from '../services/api-services';


export default function ProgramsDialog({
  open,
  onClose,
  isEditMode,
  handleSaveProgram,
  programDetails,
  handleImageUpload,
  setProgramDetails,
  onChangeStatus,
  openStatus,
  setOpenStatus,
  errorInUploadImg
}) {
  const [previewImage, setPreviewImage] = useState(null);

  // Set the preview image when edit mode is enabled
  useEffect(() => {
    // Only set the server-hosted preview if in edit mode and the icon is an existing filename (string)
    if (isEditMode && typeof programDetails.icon === 'string') {
      setPreviewImage(`${baseUrl + '/Uploads/program/download'}/${programDetails.icon}`);
    } else if (!isEditMode && !programDetails.icon) {
      // Clear preview if adding a new program and no file is selected yet
      setPreviewImage(null);
    }
  }, [isEditMode, programDetails.icon, open]);




  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      handleImageUpload(e);
    }
  };

  const onOpenStatus = () => {
    setOpenStatus(true);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <div className="flex justify-between items-center">
        <DialogTitle>{isEditMode ? 'Edit Program' : 'Add Program'}</DialogTitle>
        {isEditMode && (
          <div className="flex items-center mr-4">
            <SwitchButton onClick={onOpenStatus} status={programDetails.status} />
            <Typography className="capitalize">{programDetails.status}</Typography>
          </div>
        )}
      </div>
      <DialogContent className="space-y-7">
        <TextField
          autoFocus
          label="Program Name*"
          fullWidth
          variant="standard"
          value={programDetails.title}
          onChange={(e) => setProgramDetails({ ...programDetails, title: e.target.value })}
          error={!!programDetails.title && !programNameRegex.test(programDetails.title)}
        />
        <div className="flex flex-col md:flex-row space-x-2">
          <TextField
            label="Fee (In rupees)*"
            variant="standard"
            fullWidth
            value={programDetails.price}
            onChange={(e) => {
              const newValue = e.target.value;
              if (newValue.length <= 10) {
                setProgramDetails({ ...programDetails, price: newValue });
              }
            }}
            error={!!programDetails.price && !numberRegex.test(programDetails.price)}
          />
          <TextField
            label="Duration (in days)*"
            variant="standard"
            fullWidth
            value={programDetails.duration}
            onChange={(e) => {
              const newValue = e.target.value;
              if (newValue.length <= 3) {
                setProgramDetails({ ...programDetails, duration: newValue });
              }
            }}
            error={!!programDetails.duration && !numberRegex.test(programDetails.duration)}
          />
        </div>
        <TextField
          label="Description*"
          fullWidth
          variant="standard"
          rows={4}
          value={programDetails.description}
          onChange={(e) => {
            const newValue = e.target.value;
            if (newValue.length <= 1557) {
              setProgramDetails({ ...programDetails, description: newValue });
            }
          }}
          error={!!programDetails.description && !programDescriptionRegex.test(programDetails.description)}
          sx={{ mb: 2 }}
        />

        {/* Image Preview Section */}
        <div className="space-y-2">
          {previewImage && (
            <div className="flex flex-col ">
              <img
                src={previewImage}
                alt="Program Preview"
                className="w-40 h-40 object-cover rounded-lg border border-gray-300"
              />
            </div>
          )}
          <input type="file" accept="image/*" onChange={handleFileChange} />
          {errorInUploadImg && <Typography color="error">Program Icon is required!</Typography>}
        </div>
      </DialogContent>
      <DialogActions>
        <StyledCancelButton onClick={onClose} variant="outlined">Cancel</StyledCancelButton>
        <StyledButton
          onClick={handleSaveProgram}
          autoFocus
          disabled={
            !(programDetails.title && programNameRegex.test(programDetails.title) &&
              programDetails.duration && numberRegex.test(programDetails.duration) &&
              programDetails.price && numberRegex.test(programDetails.price) &&
              programDetails.description && programDescriptionRegex.test(programDetails.description))
          }
        >
          {isEditMode ? 'Update' : 'Save'}
        </StyledButton>
      </DialogActions>
      <StatusDialog open={openStatus} setOpen={setOpenStatus} onSubmit={onChangeStatus} status={programDetails?.status} name="Program" />
    </Dialog>
  );
}